import axios from "axios";
import React, { Component } from "react";
import cookie from "react-cookies";
import {
  Button,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
  Spinner
} from "reactstrap";
import constants from "../../Constants";

const baseURL = constants.baseURL;

// QikTruck branding colors - aligned with profile-completion styles
const brandColors = {
  primary: "#4f6367",
  secondary: "#7a9e9f",
  accent: "#b8d8d8",
  light: "#eef5db",
  dark: "#2d3c40",
  success: "#4caf50",
  danger: "#f44336"
};

// Color palette based on brandColors
const colors = {
  primary: brandColors.primary,
  text: {
    dark: "#2c3437",
    muted: "#5e7175",
    light: "#7c8a8c",
  },
  background: {
    light: "#f5f7f7",
    white: "#ffffff",
  },
  border: "#e2e7e8",
};

// Custom button styles that match profile-completion
const customStyles = {
  submitButton: {
    backgroundColor: brandColors.primary,
    borderColor: brandColors.primary,
    padding: "12px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "1px",
    borderRadius: "4px",
    transition: "background-color 0.3s",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    border: "none",
  },
  formCard: {
    borderRadius: "8px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    border: "none",
    overflow: "hidden",
  }
};

// Customer testimonials
const testimonials = [
  {
    name: "John Smith",
    company: "Fresh Foods Ltd",
    text: "QikTruck has revolutionized how we manage our deliveries. Fast, reliable, and professional.",
    avatar: "JS",
  },
  {
    name: "Sarah Johnson",
    company: "Global Exports",
    text: "The best trucking platform we've used. Their customer service is outstanding.",
    avatar: "SJ",
  },
  {
    name: "Michael Chen",
    company: "Quick Commerce",
    text: "Seamless booking process and real-time tracking make QikTruck our go-to choice.",
    avatar: "MC",
  },
];

class Section extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      success: false,
      apierror: "",
      email: "",
      message: "",
      otp: "",
      showPasswordField: false,
    };
  }
  validStepOne() {
    const { email } = this.state;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return email !== "" && emailRegex.test(email);
  }
  validStepTwo() {
    const { email, otp } = this.state;
    //numbers and characters
    const otpRegex = /^[0-9a-zA-Z]+$/;
    return email !== "" && otp !== "" && otpRegex.test(otp);
  }
  getcustomerOTP() {
    const { email } = this.state;
    this.setState({ loading: true, apierror: "" });
    axios
      .post(baseURL + "/customer-otp", { email })
      .then((response) => {
        this.setState({
          loading: false,
          showPasswordField: true,
          id: response.data.id,
        });
      })
      .catch((e) => {
        console.log(e);
        alert(
          "An account error occured please try again or contact your customer.\n Your account may need to be activated first."
        );
        this.setState({
          loading: false,
        });
      });
  }
  validateOTP() {
    const { email, otp, id } = this.state;
    this.setState({
      loading: true,
      apierror: "",
    });
    axios
      .post(baseURL + "/validate-customer-otp", {
        email,
        otp,
        id,
      })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.message && response.data.message.length > 0) {
            this.setState({
              message: response.data.message,
            });
          } else {
            // //set cookie
            cookie.save("session-id-qt", response.data["session-id-qt"], {
              path: "/",
              maxAge: 86400,
              secure: true,
            });
            cookie.save("ctName", response.data.firstname, {
              path: "/",
              maxAge: 86400,
              secure: true,
            });
            cookie.save("localsessionid", response.data.customerid, {
              path: "/",
              maxAge: 86400,
              secure: true,
            });
            cookie.save("promocode", response.data.promocode, {
              path: "/",
              maxAge: 86400,
              secure: true,
            });
            this.setState(
              {
                loading: false,
                apierror: "",
              },
              () => (window.location.href = "/dashboard")
            );
          }
        }
      })
      .catch((e) => {
        this.setState({
          loading: false,
          apierror: "Request failed. Please try again.",
        });
      });
  }
  render() {
    return (
      <React.Fragment>
        <Modal isOpen={this.state.message.length > 0} size={"sm"}>
          <ModalBody>
            <Row>
              <Col lg={4} sm={12}></Col>
              <Col lg={4} sm={12}>
                <h4 className="text-center">{this.state.message}</h4>
              </Col>
              <hr />
              <Col lg={4} sm={12}></Col>
            </Row>
          </ModalBody>
        </Modal>
        <section
          className="login-section"
          style={{
            minHeight: "100vh",
            background: `linear-gradient(150deg, ${colors.background.light} 15%, ${colors.background.white} 70%, ${colors.background.light} 94%)`,
          }}
        >
          <Container className="h-100">
            <Row className="align-items-center min-vh-100">
              {/* Left Column - Login Form */}
              <Col lg={5} md={12} className="py-5">
                <img
                  src="https://media.qiktruck.co.za/qiktruck-new-logo-bg.png"
                  alt="QikTruck Logo"
                  height="150"
                  className="mb-4"
                />
                {this.state.showPasswordField === false && (
                  <div
                    className="bg-white p-4 rounded-3"
                    style={customStyles.formCard}
                  >
                    <div>
                      <FormGroup>
                        <Label
                          for="email"
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: colors.text.dark,
                            marginBottom: "8px",
                          }}
                        >
                          Email address
                        </Label>
                        <Input
                          id="email"
                          name="email"
                          placeholder="you@company.com"
                          type="email"
                          style={{
                            fontSize: "16px",
                            padding: "8px 12px",
                            border: `1px solid ${colors.border}`,
                            borderRadius: "6px",
                            backgroundColor: colors.background.white,
                            color: colors.text.dark,
                          }}
                          defaultValue={this.state.email}
                          onChange={(e) => {
                            this.setState({ email: e.target.value });
                          }}
                          invalid={
                            this.state.email !== "" && !this.validStepOne()
                          }
                        />
                        {this.state.email !== "" && !this.validStepOne() && (
                          <div
                            className="text-danger mt-2"
                            style={{ fontSize: "14px" }}
                          >
                            Please enter a valid email address
                          </div>
                        )}
                      </FormGroup>
                      <Button
                        onClick={() => {
                          this.getcustomerOTP();
                        }}
                        disabled={!this.validStepOne() || this.state.loading}
                        className="w-100 mt-3 btn-shadow"
                        style={{
                          ...customStyles.submitButton,
                          opacity: !this.validStepOne() || this.state.loading ? "0.7" : "1",
                        }}
                      >
                        {this.state.loading ? (
                          <>
                            <Spinner size="sm" className="mr-2" /> 
                            Sending secure link...
                          </>
                        ) : (
                          <>
                            <i className="mdi mdi-email-outline mr-2"></i>
                            Continue
                          </>
                        )}
                      </Button>
                    </div>
                  </div>
                )}
                {this.state.showPasswordField && (
                  <div>
                    <div
                      onClick={() =>
                        this.setState({ showPasswordField: false })
                      }
                      style={{
                        cursor: "pointer",
                        color: colors.primary,
                        fontSize: "14px",
                        marginBottom: "24px",
                        display: "inline-flex",
                        alignItems: "center",
                      }}
                    >
                      <i className="mdi mdi-arrow-left me-2"></i>
                      Back
                    </div>
                    <h1
                      style={{
                        fontSize: "28px",
                        fontWeight: "600",
                        color: colors.text.dark,
                        marginBottom: "8px",
                        letterSpacing: "-0.3px",
                      }}
                    >
                      Enter verification code
                    </h1>
                    <p
                      style={{
                        fontSize: "16px",
                        color: colors.text.muted,
                        marginBottom: "32px",
                      }}
                    >
                      We sent a code to {this.state.email}
                    </p>
                    <div
                      className="bg-white p-4 rounded-3"
                      style={customStyles.formCard}
                    >
                      <FormGroup>
                        <Label
                          for="otp"
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: colors.text.dark,
                            marginBottom: "8px",
                          }}
                        >
                          Verification code
                        </Label>
                        <Input
                          id="otp"
                          name="otp"
                          placeholder="Enter code"
                          type="text"
                          style={{
                            fontSize: "16px",
                            padding: "8px 12px",
                            border: `1px solid ${colors.border}`,
                            borderRadius: "6px",
                            backgroundColor: colors.background.white,
                            letterSpacing: "1px",
                            color: colors.text.dark,
                          }}
                          onChange={(e) => {
                            this.setState({ otp: e.target.value });
                          }}
                          invalid={
                            this.state.otp !== "" && !this.validStepTwo()
                          }
                        />
                        {this.state.otp !== "" && !this.validStepTwo() && (
                          <div
                            className="text-danger mt-2"
                            style={{ fontSize: "14px" }}
                          >
                            Please enter a valid verification code
                          </div>
                        )}
                      </FormGroup>
                      {this.state.loading === false &&
                        this.state.apierror.length > 0 && (
                          <div
                            className="alert alert-danger text-center mt-3"
                            style={{ fontSize: "14px" }}
                          >
                            {this.state.apierror}
                          </div>
                        )}
                      <Button
                        onClick={() => {
                          this.validateOTP();
                        }}
                        disabled={!this.validStepTwo() || this.state.loading}
                        className="w-100 mt-3 btn-shadow"
                        style={{
                          ...customStyles.submitButton,
                          opacity: !this.validStepTwo() || this.state.loading ? "0.7" : "1",
                        }}
                      >
                        {this.state.loading ? (
                          <>
                            <Spinner size="sm" className="mr-2" /> 
                            Verifying...
                          </>
                        ) : (
                          <>
                            <i className="mdi mdi-login mr-2"></i>
                            Sign in
                          </>
                        )}
                      </Button>
                    </div>
                  </div>
                )}
                <div className="text-center mt-4">
                  <a
                    href="https://wa.me/27663784460?text=I%20need%20help%20with%20my%20QikTruck%20account"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      color: colors.primary,
                      fontSize: "14px",
                      textDecoration: "none",
                    }}
                  >
                    <i className="mdi mdi-whatsapp me-2"></i>
                    Contact support
                  </a>
                </div>
              </Col>

              {/* Right Column - Testimonials */}
              <Col lg={6} className="offset-lg-1 d-none d-lg-block">
                <div className="pe-4">
                  <h2
                    style={{
                      fontSize: "24px",
                      fontWeight: "600",
                      color: colors.text.dark,
                      marginBottom: "40px",
                      letterSpacing: "-0.3px",
                    }}
                  >
                    Trusted by leading companies
                  </h2>

                  {testimonials.map((testimonial, index) => (
                    <div
                      key={index}
                      className="mb-4 bg-white rounded-3 p-4"
                      style={{
                        boxShadow:
                          "0px 1px 3px rgba(79, 99, 103, 0.1), 0px 1px 2px rgba(79, 99, 103, 0.06)",
                        borderLeft: `4px solid ${colors.primary}`,
                      }}
                    >
                      <p
                        style={{
                          fontSize: "15px",
                          color: colors.text.muted,
                          lineHeight: "1.6",
                          marginBottom: "16px",
                        }}
                      >
                        "{testimonial.text}"
                      </p>
                      <div className="d-flex align-items-center">
                        <div
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "16px",
                            backgroundColor: colors.primary,
                            color: colors.background.white,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                        >
                          {testimonial.avatar}
                        </div>
                        <div className="ms-3">
                          <h5
                            style={{
                              fontSize: "14px",
                              fontWeight: "500",
                              color: colors.text.dark,
                              marginBottom: "2px",
                            }}
                          >
                            {testimonial.name}
                          </h5>
                          <p
                            style={{
                              fontSize: "14px",
                              color: colors.text.light,
                              marginBottom: "0",
                            }}
                          >
                            {testimonial.company}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
